export const NEW_ORDER_REQUEST = "NEW_ORDER_REQUEST";
export const NEW_ORDER_SUCCESS = "NEW_ORDER_SUCCESS";
export const NEW_ORDER_FAIL = "NEW_ORDER_FAIL";

export const MY_ORDERS_REQUEST = "MY_ORDERS_REQUEST";
export const MY_ORDERS_SUCCESS = "MY_ORDERS_SUCCESS";
export const MY_ORDERS_FAIL = "MY_ORDERS_FAIL";

export const ORDER_DETAILS_REQUEST = "ORDER_DETAILS_REQUEST";
export const ORDER_DETAILS_SUCCESS = "ORDER_DETAILS_SUCCESS";
export const ORDER_DETAILS_FAIL = "ORDER_DETAILS_FAIL";

export const PAYMENT_STATUS_REQUEST = "PAYMENT_STATUS_REQUEST";
export const PAYMENT_STATUS_SUCCESS = "PAYMENT_STATUS_SUCCESS";
export const PAYMENT_STATUS_FAIL = "PAYMENT_STATUS_FAIL";

export const ALL_ORDERS_REQUEST = "ALL_ORDERS_REQUEST";
export const ALL_ORDERS_SUCCESS = "ALL_ORDERS_SUCCESS";
export const ALL_ORDERS_FAIL = "ALL_ORDERS_FAIL";

export const UPDATE_ORDER_REQUEST = "UPDATE_ORDER_REQUEST";
export const UPDATE_ORDER_SUCCESS = "UPDATE_ORDER_SUCCESS";
export const UPDATE_ORDER_RESET = "UPDATE_ORDER_RESET";
export const UPDATE_ORDER_FAIL = "UPDATE_ORDER_FAIL";

export const DELETE_ORDER_REQUEST = "DELETE_ORDER_REQUEST";
export const DELETE_ORDER_SUCCESS = "DELETE_ORDER_SUCCESS";
export const DELETE_ORDER_RESET = "DELETE_ORDER_RESET";
export const DELETE_ORDER_FAIL = "DELETE_ORDER_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";

// Cancel order (customer)
export const CANCEL_ORDER_REQUEST = "CANCEL_ORDER_REQUEST";
export const CANCEL_ORDER_SUCCESS = "CANCEL_ORDER_SUCCESS";
export const CANCEL_ORDER_FAIL = "CANCEL_ORDER_FAIL";
export const CANCEL_ORDER_RESET = "CANCEL_ORDER_RESET";

// Return request (customer)
export const RETURN_ORDER_REQUEST = "RETURN_ORDER_REQUEST";
export const RETURN_ORDER_SUCCESS = "RETURN_ORDER_SUCCESS";
export const RETURN_ORDER_FAIL = "RETURN_ORDER_FAIL";
export const RETURN_ORDER_RESET = "RETURN_ORDER_RESET";

// Tracking
export const TRACKING_REQUEST = "TRACKING_REQUEST";
export const TRACKING_SUCCESS = "TRACKING_SUCCESS";
export const TRACKING_FAIL = "TRACKING_FAIL";

// Admin: Create shipment
export const CREATE_SHIPMENT_REQUEST = "CREATE_SHIPMENT_REQUEST";
export const CREATE_SHIPMENT_SUCCESS = "CREATE_SHIPMENT_SUCCESS";
export const CREATE_SHIPMENT_FAIL = "CREATE_SHIPMENT_FAIL";
export const CREATE_SHIPMENT_RESET = "CREATE_SHIPMENT_RESET";

// Admin: Process return
export const PROCESS_RETURN_REQUEST = "PROCESS_RETURN_REQUEST";
export const PROCESS_RETURN_SUCCESS = "PROCESS_RETURN_SUCCESS";
export const PROCESS_RETURN_FAIL = "PROCESS_RETURN_FAIL";
export const PROCESS_RETURN_RESET = "PROCESS_RETURN_RESET";

// Admin: Refund
export const REFUND_ORDER_REQUEST = "REFUND_ORDER_REQUEST";
export const REFUND_ORDER_SUCCESS = "REFUND_ORDER_SUCCESS";
export const REFUND_ORDER_FAIL = "REFUND_ORDER_FAIL";
export const REFUND_ORDER_RESET = "REFUND_ORDER_RESET";